export default "__VITE_ASSET__BtZiBclC__"